import { useContext } from 'react';
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../components/common/Table';
import { Button, GreenSwitch } from '../../../../components/common';
import { directPayment } from '../../../../utils';
import FarmContext from '../../../../store/farm-context';
import { downloadCSVFile, plotsOwnershipTableToCSV } from '../../CSVFunctions';

export default function PlotsOwnershipTable(props) {
  const farmCTX = useContext(FarmContext);
  const getCSV = () => {
    directPayment
      .fields(props.id, farmCTX.farmID)
      .then(function (result) {
        if (result.status === 403) {
          window.location.href = '/login';
        }
        if (result.data.length > 0) {
        }
        props.setFieldsData(result.data);
        downloadCSVFile(plotsOwnershipTableToCSV(result.data));
      })
      .catch(function (err) {});
  };

  const handleOwnershipChange = (event, row) => {
    directPayment.fieldStatus(
      props.id,
      farmCTX.farmID,
      row.id,
      event.target.checked
    );
  };

  return (
    <>
      <Grid item xs={12} ref={props.plotsOwnershipTableRef}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Numer teryt</StyledTableCell>
                <StyledTableCell align="center">
                  Powierzchnia (ha)
                </StyledTableCell>
                <StyledTableCell align="center">
                  Forma użytkowania gruntu
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.fieldsData == null
                ? null
                : props.fieldsData.map((row) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell component="th" scope="row">
                        {row.teryt}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {Number(row.area.toFixed(2))}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Dzierżawa{' '}
                        <GreenSwitch
                          defaultChecked={row.owned}
                          onChange={(e) => handleOwnershipChange(e, row)}
                        />{' '}
                        Własność
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={5}>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          onClick={getCSV}
          sx={{ mt: 3 }}
        >
          Eksportuj do CSV
        </Button>
      </Grid>
    </>
  );
}
